import { Component, Host, Prop, h } from '@stencil/core';
import { getAvatarSize, getPlayerAvatar } from '@utils/imageUtils';
import { SizeVariant } from 'src/types';

@Component({
  tag: 'sportsline-player-avatar',
  styleUrl: 'sportsline-player-avatar.css',
  shadow: true,
})
export class SportslinePlayerAvatar {
  /**
   * The avatar props, the avatarUrl is the image URL, altText is the alt text for the image, and size is the size of the avatar.
   */
  @Prop() playerId: string = '-1';
  /**
   * The avatar props, the avatarUrl is the image URL, altText is the alt text for the image, and size is the size of the avatar.
   */
  @Prop() alt: string;
  /**
   * The avatar props, the avatarUrl is the image URL, altText is the alt text for the image, and size is the size of the avatar.
   */
  @Prop() size: SizeVariant;

  render() {
    return (
      <Host>
        <img
          class={{
            'sportsline-player-avatar': true,
            'sportsline-player-avatar--small': this.size === 'small',
            'sportsline-player-avatar--medium': this.size === 'medium',
            'sportsline-player-avatar--large': this.size === 'large',
            'sportsline-player-avatar--extra-large': this.size === 'extra-large',
          }}
          src={getPlayerAvatar(this.playerId)}
          width={getAvatarSize(this.size)}
          height={getAvatarSize(this.size)}
          alt={this.alt}
          loading="lazy"
        />
      </Host>
    );
  }
}
